import { render, staticRenderFns } from "./exhibitionGoodsDetail.vue?vue&type=template&id=15bef10c&scoped=true"
import script from "./exhibitionGoodsDetail.vue?vue&type=script&lang=js"
export * from "./exhibitionGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./exhibitionGoodsDetail.vue?vue&type=style&index=0&id=15bef10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bef10c",
  null
  
)

export default component.exports